<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    width="486px"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    :destroy-on-close="true"
    @ok="formHandle"
    @cancel="cancelHandle"
  >
    <div class="set-area-dia">
      <div class="foreign-type">
        <a-checkbox
          :checked="!!itemData.fieldconfig.enableforeign"
          @change="handleChange"
        >
          {{ $t('message["1084"]') }}
        </a-checkbox>
      </div>
      <div
        v-show="isTreeShow"
        class="tree-area-box scroll_bar_beautify_ff"
      >
        <a-tree
          v-model="checkedKeys"
          checkable
          :expanded-keys="expandedKeys"
          :auto-epand-parent="autoExpandParent"
          :selected-keys="selectedKeys"
          :tree-data="datas"
          @expand="onExpand"
          @check="onCheck"
        />
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { cloneDeep } from 'lodash'
export default {
  components: {
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    cloneData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      expandedKeys: this.itemData.options2,
      autoExpandParent: true,
      checkedKeys: this.itemData.options2,
      selectedKeys: [],
      isTreeShow: !!this.itemData.fieldconfig.enableforeign
    }
  },
  computed: {
    ...mapState('config/collect', ['areaDatas', 'areaDatasReady']),
    datas () {
      if (this.areaDatasReady) {
        this.handleDatas(this.areaDatas)
        return this.areaDatas
      } else {
        return []
      }
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    },
    modalTit () {
      return this.$t('message["1016"]')
    }
  },
  mounted () {
    // this.isTreeShow = !!this.itemData.fieldconfig.enableforeign
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('organization/org', ['ajaxCreateProject', 'getAdminId']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    formHandle () {
      if (this.checkedKeys.length) {
        this.checkedKeys.forEach((item, index) => {
          this.arrLoop(this.datas, item, index)
        })
      }
      this.itemData.options2 = this.checkedKeys
      const options = cloneDeep(this.itemData.options2)
      this.$set(this.itemData, 'options', options)
      // this.$delete(this.itemData, 'options2')
      this.isLimitDialogShow = false
    },
    onExpand (expandedKeys) {
      console.log('onExpand', expandedKeys)
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onCheck (checkedKeys, e) {
      this.checkedKeys = checkedKeys
    },
    arrLoop (arr, i, index1) {
      arr.forEach((item, index) => {
        if (item.children && item.children.length) {
          if (item.key === i) {
            this.checkedKeys.splice(index1, 1)
          } else {
            this.arrLoop(item.children, i, index1)
          }
        }
      })
    },
    handleDatas (arr) {
      arr.forEach((item, index) => {
        if (item.child && item.child.length) {
          item.children = item.child
          this.handleDatas(item.children)
        }
        item.key = item.code
        item.title = item.name
      })
    },
    handleChange (e) {
      const isChecked = e.target.checked
      this.itemData.fieldconfig.enableforeign = isChecked ? 1 : 0
      this.isTreeShow = isChecked
    },
    cancelHandle () {
      this.isLimitDialogShow = false
      // this.$set(this.itemData, {
      // options2: this.cloneData.options2, options: this.cloneData.options, fieldconfig: this.cloneData.fieldconfig })
      this.$set(this.itemData, 'options', this.cloneData.options)
      this.$set(this.itemData, 'options2', this.cloneData.options2)
      this.$set(this.itemData.fieldconfig, 'enableforeign', this.cloneData.fieldconfig.enableforeign)
      this.expandedKeys = this.cloneData.options2
      this.checkedKeys = this.cloneData.options2
      this.isTreeShow = !!this.cloneData.fieldconfig.enableforeign * 1
    }

  }
}
</script>

<style lang="scss" scoped>
.set-area-dia::v-deep {
  margin: 16px 0 16px 24px;
  .ant-tree-switcher-icon {
    font-size: 16px !important;
    color: #d6d6d6;
  }
}
.tree-area-box {
  max-height: 330px;
  overflow-y: auto;
}
</style>
